import _ from 'lodash';

const TD = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
const KASPERSKY = 'ec3b6d8e-f9f0-42f4-9c09-294368cbe683';

const isTeam = (id, teamId) => _.eq(id, teamId);

module.exports = {
  isTeam,
  TD,
  KASPERSKY,
};



/** WEBPACK FOOTER **
 ** ./src/utils/private-data-whitelist.js
 **/